export default "__VITE_ASSET__BOry4hfw__"